angular.module('impactx.catalog').service('CatalogRuleService', CatalogRuleService);
CatalogRuleService.$inject = ['dataGen', '$route', 'ToastService'];

function CatalogRuleService(dataGen, $route, ToastService) {

    this.toggleStatus = function (id) {
        var dataObj = {
            cmriId: id
        }, tempScope = {};

        dataGen.postAsForm(tempScope, dataObj, "/catalog/togglerulestatusforcat").then(function () {
            $route.reload();
            if (impactX.isDefined(tempScope, 'trns.activateMessage')) {
                ToastService.openStandardToast(tempScope.trns.activateMessage);
            }
        });
    };

    this.runRuleCheck = function(catId, message) {
        var dataObj = {
            catId: catId
        };
        if (message){
            ToastService.openStandardToast(message);
        }
        dataGen.postAsForm({}, dataObj, "/catalog/rulecheckrun", false, true);
    };
    
    this.ignoreRules = function(catId, ruleIds, useLogItems) {
        var dataObj = {
            catId: catId,
            ruleIds : ruleIds,
            useLogItems: useLogItems
        }, tempScope = {};
        
        dataGen.getData(tempScope, dataObj, "/catalog/rule/ignore").then(function() {
            $route.reload();
            if (impactX.isDefined(tempScope, 'trns.successMessage')) {
                ToastService.openStandardToast(tempScope.trns.successMessage)
            }
        });
    };

    this.unIgnoreRules = function(catId, ruleIds, useLogItems) {
        var dataObj = {
            catId: catId,
            ruleIds : ruleIds,
            useLogItems: useLogItems
        }, tempScope = {};

        dataGen.getData(tempScope, dataObj, "/catalog/rule/unignore").then(function() {
            $route.reload();
            if (impactX.isDefined(tempScope, 'trns.successMessage')) {
                ToastService.openStandardToast(tempScope.trns.successMessage)
            }
        });
    };

}